export default {
    create: {
        cancel: {
            button: 'Отказать в обмене',
            bvModal: 'Вы уверены, что хотите отменить оформление обмена товара?',
        },

        create: {
            headerTitle: 'Внимание!',
            tooltip: 'Не указано количество товаров для обмена.',
            label: 'Сформировать обмен',
            h3: 'Данные отправлены!',
            bvModal:
        'Подтвердите завершение оформления обмена. После подтверждения скорректировать данные будет невозможно.',
        },

        form: {
            fields: {
                orderId: 'Заказ №',
                exchangeFio: 'ФИО клиента',
                exchangePhone: 'Телефон клиента',
                exchangeReasonId: 'Причина обмена',
                inspection: 'Осмотр товара',
                defectsDescription: 'Описание брака',
                exchangeComments: 'Комментарий',
            },

            exchangeReasons: {
                defect: 'Брак',
                notLike: 'Товар не подошел',
            },
        },
    },

    index: {
        exchangeCheck: 'Оформление обмена',
        exchangeList: 'Список операций по обмену',
    },

    list: {
        filter: {
            filters: {
                id: 'Номер операции',
                orderId: 'Номер заказа',
                exchangeDate: 'Дата операции',
            },

            buttonClear: 'Очистить',
        },
    },

    print: 'Печать заявления на обмен/возврат товара',

    view: {
        h1: 'Операция по обмену товара в заказе № {orderId}',
        orderWithDate: '{id} от {date}',
    },
};